'use client';

import clsx from 'clsx';
import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
interface SelectTierButtonProps {
  onClick: () => void;
  title: string;
  key?: string;
  className?: string;
  isAddingToCart: boolean;
}
export default function SelectTierButton({
  onClick,
  title,
  key,
  className,
  isAddingToCart
}: SelectTierButtonProps) {
  return <LoadingButton onClick={onClick} size='medium' variant='bright' className={clsx('h-fit max-h-fit rounded-2xl', className)} key={key} disabled={isAddingToCart} data-sentry-element="LoadingButton" data-sentry-component="SelectTierButton" data-sentry-source-file="SelectTierButton.tsx">
      {title}
    </LoadingButton>;
}